import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { SrCheckListCrewsGet, SrChecklistService } from '@app/services/sr-checklist.service';

@Component({
    selector: 'tt-sr-check-list-crews',
    templateUrl: './sr-check-list-crews.component.html',
    styleUrls: ['./sr-check-list-crews.component.css'],
    standalone: false,
})
export class SrCheckListCrewsComponent implements OnInit {
    public page?: SrCheckListCrewsGet;
    public crews: Item[] = [];

    constructor(
        private readonly checklist: SrChecklistService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        const params = { checklistdata_keyno: String(this.navigator?.params['checklistdata_keyno'] ?? '') };
        const [page, crews] = await Promise.all([this.checklist.getCrews(params), this.checklist.getCrewList(params)]);
        this.page = page;
        this.crews = crews;
    }
}
